module.exports = __webpack_public_path__ + "img/logo.6867a838.png";